export default "https://cdn-static.gokick.com/assets/6600ddf3ffcd3e3653ecf6807c0977bcbaa0931f/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";